import { createSelector } from '@ngrx/store';
import { InstrumentType } from '@zero/shared/util-models';
import { positionsFeature } from './positions.reducers';

export const selectPositions = createSelector(positionsFeature.selectAll, (positions) => {
  return positions.filter((position) => position.type !== InstrumentType.Crypto);
});

export const selectCryptos = createSelector(positionsFeature.selectAll, (positions) => {
  return positions.filter((position) => position.type === InstrumentType.Crypto);
});

export const selectPositionsHaveNotes = createSelector(selectPositions, (positions) => {
  return positions.some((position) => position.note?.note);
});
export const selectCryptosHaveNotes = createSelector(selectCryptos, (cryptos) => {
  return cryptos.some((crypto) => crypto.note?.note);
});

export const selectPerformanceReady = createSelector(
  positionsFeature.selectAll,
  positionsFeature.selectPositionsInitialLoaded,
  positionsFeature.selectPerformanceCalculated,
  (positions, loaded, calculated) => {
    if (!loaded) {
      return false;
    }

    if (positions.length === 0) {
      return true;
    }

    return calculated;
  },
);

export const selectPositionByIsin = (isin: string) => createSelector(positionsFeature.selectEntities, (entities) => entities[isin]);
export const selectPositionStocksISINs = createSelector(positionsFeature.selectAll, (positions) =>
  positions.filter(({ type }) => type === InstrumentType.Share).map(({ isin }) => isin),
);
